import React, { useEffect, useState } from 'react';
import HeaderMenu from './Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { paymentCheck } from './Backend';
import { FaStripe } from "react-icons/fa";
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const PaymentCheck = () => {
  const [paymentStatus, setPaymentStatus] = useState('Checking payment...');
  const [loading, setLoading] = useState(true);
  const [paymentFailed, setPaymentFailed] = useState(false); // New state for payment failure
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const sessionId = query.get('session_id');

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        if (sessionId) {
          paymentCheck({ sessionId })
            .then((result) => {
              console.log('Payment check result:', result);
              if (result.success) {
                setPaymentStatus('Payment was successful!');
              } else {
                setPaymentStatus('Payment failed. Please try again.');
                setPaymentFailed(true); // Set paymentFailed to true if payment fails
              }
              setLoading(false);
            })
            .catch((error) => {
              console.error('Error during payment check:', error);
              setPaymentStatus('An error occurred. Please try again later.');
              setPaymentFailed(true); // Set paymentFailed to true on error
              setLoading(false);
            });
        } else {
          console.log('No session ID found');
          setLoading(false);
        }
      } else {
        setPaymentStatus('Please log in to check your payment status.');
        setLoading(false);
        navigate('/login');
      }
    });

    return () => unsubscribe();
  }, [sessionId, navigate]);

  const handleGoBack = () => {
    navigate('/'); // Redirect to home page
  };

  return (
    <div>
      <HeaderMenu />
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="card shadow p-3">
          <div className="card-body text-center">
            <div><FaStripe className='display-2' /></div>
            {loading ? (
              <>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div className='mt-3'>{paymentStatus}</div>
              </>
            ) : (
              <>
                <p>{paymentStatus}</p>
                {paymentFailed && (
                  <button className="btn btn-outline-dark mt-3" onClick={handleGoBack}>
                    Go Back
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCheck;